import Paragraph from "immigram-ui-cmon/src/components/Paragraph/Paragraph";
import { TFunction } from "next-i18next";
import { ReactNode } from "react";

export enum CareerRole {
  SoftwareEngineer = 1,
  Enterpreneur = 2,
  Investor = 3,
  ProductManager = 4,
  Designer = 5,
  QA = 6,
  Marketer = 7,
  BizDev = 8,
  SolutionSalesSpecialist = 9,
}

export type FieldText = {
  heading: ReactNode;
  description: ReactNode;
  example: ReactNode;
};

export const getCompanyBriefDescriptionText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  return {
    heading:
      t("application:profJorn.companyId.field.brief.v2.desc_heading") ?? "",
    description: (
      <ul className="mb-6">
        <li>{t("application:profJorn.companyId.field.brief.v2.l1")}</li>
        <li>{t("application:profJorn.companyId.field.brief.v2.l2")}</li>
        <li>{t("application:profJorn.companyId.field.brief.v2.l3")}</li>
      </ul>
    ),
    example:
      (
        {
          [CareerRole.ProductManager]: t(
            "application:profJorn.companyId.field.brief.productManager.example"
          ),
          [CareerRole.Designer]: t(
            "application:profJorn.companyId.field.brief.designer.example"
          ),
        } as Record<CareerRole, any>
      )[careerRoleId] || "",
  };
};

export const getCompanyHowJoinedText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Investor) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.howJoined.investor.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.howJoined.investor.desc") || "",
      example:
        t("application:profJorn.companyId.field.howJoined.investor.example") ||
        "",
    };
  }

  return {
    heading:
      t("application:profJorn.companyId.field.howJoined.desc_heading") || "",
    description:
      t("application:profJorn.companyId.field.howJoined.v2.desc") || "",
    example:
      t("application:profJorn.companyId.field.howJoined.v2.example1") || "",
  };
};

export const getProjectPositionText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  return {
    heading:
      t("application:profJorn.companyId.field.projectPosition.desc_heading") ||
      "",
    description:
      t("application:profJorn.companyId.field.projectPosition.v2.desc") || "",
    example:
      (
        {
          [CareerRole.Marketer]: t(
            "application:profJorn.companyId.field.projectPosition.marketer.example"
          ),
          [CareerRole.ProductManager]: t(
            "application:profJorn.companyId.field.projectPosition.productManager.example"
          ),
          [CareerRole.SoftwareEngineer]: t(
            "application:profJorn.companyId.field.projectPosition.softwareEngineer.example"
          ),
          [CareerRole.Designer]: t(
            "application:profJorn.companyId.field.projectPosition.designer.example"
          ),
          [CareerRole.BizDev]: t(
            "application:profJorn.companyId.field.projectPosition.bizDev.example"
          ),
          [CareerRole.SolutionSalesSpecialist]: t(
            "application:profJorn.companyId.field.projectPosition.solutionSalesSpecialist.example"
          ),
        } as Record<CareerRole, any>
      )[careerRoleId] || "",
  };
};

export const getProjectAimText = (t: TFunction, careerRoleId: CareerRole) => {
  if (careerRoleId === CareerRole.Investor) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.projectAim.investor.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.projectAim.investor.desc") ||
        "",
      example: (
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t(
            "application:profJorn.companyId.field.projectAim.investor.example"
          )}
        </Paragraph>
      ),
    };
  }

  return {
    heading:
      t("application:profJorn.companyId.field.projectAim.v2.descHeading") || "",
    description:
      t("application:profJorn.companyId.field.projectAim.v2.desc") || "",
    example: (
      <>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.projectAim.example1")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.projectAim.example2")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.projectAim.example3")}
        </Paragraph>
      </>
    ),
  };
};

export const getProjectImportanceToCompanyText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Marketer) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.importance.marketer.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.importance.marketer.desc") ||
        "",
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.importance.marketer.example"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  if (careerRoleId === CareerRole.ProductManager) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.importance.productManager.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.importance.productManager.desc"
        ) || "",
      example: t(
        "application:profJorn.companyId.field.importance.productManager.example"
      ),
    };
  }

  if (careerRoleId === CareerRole.SoftwareEngineer) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.importance.softwareEngineer.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.importance.softwareEngineer.desc"
        ) || "",
      example:
        t(
          "application:profJorn.companyId.field.importance.softwareEngineer.example"
        ) || "",
    };
  }

  if (careerRoleId === CareerRole.Designer) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.importance.designer.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.importance.designer.desc") ||
        "",
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.importance.designer.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.importance.designer.example2"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  if (careerRoleId === CareerRole.BizDev) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.importance.bizDev.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.importance.bizDev.desc") || "",
      example:
        t("application:profJorn.companyId.field.importance.bizDev.example") ||
        "",
    };
  }

  if (careerRoleId === CareerRole.SolutionSalesSpecialist) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.importance.solutionSalesSpecialist.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.importance.solutionSalesSpecialist.desc"
        ) || "",
      example:
        t(
          "application:profJorn.companyId.field.importance.solutionSalesSpecialist.example"
        ) || "",
    };
  }

  if (careerRoleId === CareerRole.Investor) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.importance.investor.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.importance.investor.desc") ||
        "",
      example:
        t("application:profJorn.companyId.field.importance.investor.example") ||
        "",
    };
  }

  return {
    heading:
      t("application:profJorn.companyId.field.importance.desc_heading") || "",
    description: "",
    example: "",
  };
};

export const getProjectWhatDidYouDoText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Marketer) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.whatDidYou.marketer.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.whatDidYou.marketer.desc") ||
        "",
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.marketer.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.marketer.example2"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.marketer.example3"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.marketer.example4"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.marketer.example5"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.marketer.example6"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.marketer.example7"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.marketer.example8"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  if (careerRoleId === CareerRole.ProductManager) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.whatDidYou.productManager.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.whatDidYou.productManager.desc"
        ) || "",
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.productManager.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.productManager.example2"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.productManager.example3"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  if (careerRoleId === CareerRole.SoftwareEngineer) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.whatDidYou.softwareEngineer.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.whatDidYou.softwareEngineer.desc"
        ) || "",
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.softwareEngineer.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.softwareEngineer.example2"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  if (careerRoleId === CareerRole.Designer) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.whatDidYou.designer.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.whatDidYou.designer.desc") ||
        "",
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.designer.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.designer.example2"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.designer.example3"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.designer.example4"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.designer.example5"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  if (careerRoleId === CareerRole.BizDev) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.whatDidYou.bizDev.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.whatDidYou.bizDev.desc") || "",
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.bizDev.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.bizDev.example2"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.bizDev.example3"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.bizDev.example4"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  if (careerRoleId === CareerRole.SolutionSalesSpecialist) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.whatDidYou.solutionSalesSpecialist.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.whatDidYou.solutionSalesSpecialist.desc"
        ) || "",
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.solutionSalesSpecialist.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.solutionSalesSpecialist.example2"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.solutionSalesSpecialist.example3"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.whatDidYou.solutionSalesSpecialist.example4"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  return {
    heading:
      t("application:profJorn.companyId.field.whatDidYou.desc_heading") || "",
    description:
      t("application:profJorn.companyId.field.whatDidYou.desc_short") || "",
    example: (
      <Paragraph className="my-0 text-[14px] text-black-800">
        {t("application:profJorn.companyId.field.whatDidYou.example")}
      </Paragraph>
    ),
  };
};

export const getProjectLeadershipText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Marketer) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.leadership.marketer.desc_heading"
        ) || "",
      description: (
        <Paragraph>
          {t("application:profJorn.companyId.field.leadership.marketer.desc")}
        </Paragraph>
      ),
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.leadership.marketer.example"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  if (careerRoleId === CareerRole.BizDev) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.leadership.bizDev.desc_heading"
        ) || "",
      description: (
        <Paragraph>
          {t("application:profJorn.companyId.field.leadership.bizDev.desc")}
        </Paragraph>
      ),
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.leadership.bizDev.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.leadership.bizDev.example2"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  if (careerRoleId === CareerRole.SolutionSalesSpecialist) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.leadership.solutionSalesSpecialist.desc_heading"
        ) || "",
      description: (
        <Paragraph>
          {t(
            "application:profJorn.companyId.field.leadership.solutionSalesSpecialist.desc"
          )}
        </Paragraph>
      ),
      example: (
        <>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.leadership.solutionSalesSpecialist.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.leadership.solutionSalesSpecialist.example2"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  return {
    heading: "",
    description: "",
    example: "",
  };
};

export const getProjectUnfairAdvantageText = (
  t: TFunction,
  careerRoleId: CareerRole,
  options?: { isO1Visa?: boolean }
) => {
  if (careerRoleId === CareerRole.Investor) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.unfairAdvantage.investor.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.unfairAdvantage.investor.desc"
        ) || "",
      example:
        t(
          "application:profJorn.companyId.field.unfairAdvantage.investor.example"
        ) || "",
    };
  }

  return {
    heading:
      t(
        options?.isO1Visa
          ? "application:o1.profJorn.companyId.field.unfairAdvantage.v2.desc_heading"
          : "application:profJorn.companyId.field.unfairAdvantage.v2.desc_heading"
      ) || "",
    description: (
      <>
        <Paragraph>
          {t("application:profJorn.companyId.field.unfairAdvantage.v2.desc.1")}
        </Paragraph>
        <Paragraph>
          {t("application:profJorn.companyId.field.unfairAdvantage.v2.desc.2")}
        </Paragraph>
        <Paragraph>
          {t("application:profJorn.companyId.field.unfairAdvantage.v2.desc.3")}
        </Paragraph>
        <Paragraph>
          {t("application:profJorn.companyId.field.unfairAdvantage.v2.desc.4")}
        </Paragraph>
        <Paragraph>
          {t("application:profJorn.companyId.field.unfairAdvantage.v2.desc.5")}
        </Paragraph>
      </>
    ),
    example: (
      <>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.unfairAdvantage.example.1")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.unfairAdvantage.example.2")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.unfairAdvantage.example.3")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.unfairAdvantage.example.4")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.unfairAdvantage.example.5")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.unfairAdvantage.example.6")}
        </Paragraph>
      </>
    ),
  };
};

export const getProjectChallengingText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Investor) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.challenging.investor.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.challenging.investor.desc") ||
        "",
      example:
        t(
          "application:profJorn.companyId.field.challenging.investor.example"
        ) || "",
    };
  }

  return {
    heading:
      t("application:profJorn.companyId.field.challenging.v2.desc_heading") ||
      "",
    description:
      t("application:profJorn.companyId.field.challenging.v2.desc") || "",
    example: (
      <>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.challenging.v2.example.1")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.challenging.v2.example.2")}
        </Paragraph>
      </>
    ),
  };
};

export const getProjectUnusualApproachesText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  // TODO: Remove designer
  if (
    careerRoleId === CareerRole.Marketer ||
    careerRoleId === CareerRole.Designer
  ) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.unusualApproaches.marketer.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.unusualApproaches.marketer.desc"
        ) || "",
      example: (
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t(
            "application:profJorn.companyId.field.unusualApproaches.marketer.example"
          )}
        </Paragraph>
      ),
    };
  }

  return {
    heading: "",
    description: "",
    example: "",
  };
};

export const getProjectFeaturedInMediaText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  return {
    heading:
      t("application:profJorn.companyId.field.featuredInMedia.desc_heading") ||
      "",
    description:
      t("application:profJorn.companyId.field.featuredInMedia.desc") || "",
    example:
      (
        {
          [CareerRole.ProductManager]: t(
            "application:profJorn.companyId.field.featuredInMedia.productManager.example"
          ),
          [CareerRole.Designer]: t(
            "application:profJorn.companyId.field.featuredInMedia.designer.example"
          ),
        } as Record<CareerRole, any>
      )[careerRoleId] || "",
  };
};

export const getProjectMetricsText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Investor) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.metrics.investor.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.field.metrics.investor.desc") || "",
      example:
        t("application:profJorn.companyId.field.metrics.investor.example") ||
        "",
    };
  }

  return {
    heading:
      t("application:profJorn.companyId.field.metrics.v2.desc_heading") || "",
    description: (
      <>
        <Paragraph>
          {t("application:profJorn.companyId.field.metrics.v2.desc.1")}
        </Paragraph>
        <Paragraph>
          {t("application:profJorn.companyId.field.metrics.v2.desc.2")}
        </Paragraph>
      </>
    ),
    example: (
      <>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.metrics.v2.example.1")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.metrics.v2.example.2")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.metrics.v2.example.3")}
        </Paragraph>
        <Paragraph className="my-0 text-[14px] text-black-800">
          {t("application:profJorn.companyId.field.metrics.v2.example.4")}
        </Paragraph>
      </>
    ),
  };
};

export const getSuccessAffectText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Investor) {
    return {
      heading:
        t(
          "application:profJorn.companyId.successAffect.investor.desc_heading"
        ) || "",
      description: "",
      example:
        t("application:profJorn.companyId.successAffect.investor.example") ||
        "",
    };
  }

  return {
    heading:
      t("application:profJorn.companyId.successAffect.v2.desc_heading") || "",
    description: "",
    example: "",
  };
};

export const getSuccessAffectOthersText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Designer) {
    return {
      heading:
        t(
          "application:profJorn.companyId.successAffectOthers.designer.desc_heading"
        ) || "",
      description:
        t("application:profJorn.companyId.successAffectOthers.designer.desc") ||
        "",
      example: "",
    };
  }

  return {
    heading: "",
    description: "",
    example: "",
  };
};

export const getWhoWasItWithText = (t: TFunction) => {
  return {
    heading:
      t("application:profJorn.companyId.whoWasItWith.desc_heading") || "",
    description: t("application:profJorn.companyId.whoWasItWith.desc") || "",
    example: t("application:profJorn.companyId.whoWasItWith.example") || "",
  };
};

export const getAnythingElseYouDidText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Investor) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.anythingElseYouDid.investor.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.anythingElseYouDid.investor.desc"
        ) || "",
      example:
        t(
          "application:profJorn.companyId.field.anythingElseYouDid.investor.example"
        ) || "",
    };
  }

  return {
    heading:
      t("application:profJorn.companyId.anythingElseYouDid.desc_heading") || "",
    description:
      t("application:profJorn.companyId.anythingElseYouDid.desc") || "",
    example: t("application:profJorn.companyId.successAffect.example") || "",
  };
};

export const getFutureThingsToDoText = (t: TFunction) => {
  return {
    heading:
      t("application:profJorn.companyId.futureThingsToDo.desc_heading") || "",
    description: "",
    example: t("application:profJorn.companyId.futureThingsToDo.example") || "",
  };
};

export const getProjectProductFeaturesText = (
  t: TFunction,
  careerRoleId: CareerRole
) => {
  if (careerRoleId === CareerRole.Marketer) {
    return {
      heading:
        t(
          "application:profJorn.companyId.field.projectProductFeatures.marketer.desc_heading"
        ) || "",
      description:
        t(
          "application:profJorn.companyId.field.projectProductFeatures.marketer.desc"
        ) || "",
      example: (
        <>
          w
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.projectProductFeatures.marketer.example1"
            )}
          </Paragraph>
          <Paragraph className="my-0 text-[14px] text-black-800">
            {t(
              "application:profJorn.companyId.field.projectProductFeatures.marketer.example2"
            )}
          </Paragraph>
        </>
      ),
    };
  }

  return {
    heading: "",
    description: "",
    example: "",
  };
};
